import { render } from "./Services.vue?vue&type=template&id=0a8df8af&ts=true"
import script from "./Services.vue?vue&type=script&lang=ts"
export * from "./Services.vue?vue&type=script&lang=ts"

import "./Services.vue?vue&type=style&index=0&id=0a8df8af&lang=scss"

import exportComponent from "/home/runner/work/digital-creative-website/digital-creative-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__